<template>
    <div>
        <div
            class="message-text text-dark fw-bold mw-lg-400px fs-14px rounded p-5"
        >
            <div class="mb-4 d-flex align-items-center">
                <i class="bi bi-file-earmark-text me-2 fs-1"></i>
                <span class="fs-5" >
                    {{ $t("file") }}
                </span>
            </div>
            <div class="text-link fw-normal" @click="openDocument">
                {{ fileName }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import i18n from "@/locales/index.js";

const props = defineProps({
    message: Object,
});

const fileName = computed(() => {
    if (!props.message?.content?.document?.filename) {
        console.warn("document filename is not exists");
        return i18n.global.t("document");
    }
    return props.message.content?.document?.filename;
});
const documentUrl = computed(() => {
    if (!props.message?.content?.document?.filename) {
        console.warn("document url is not exists");
        return "";
    }
    return props.message.content?.document?.url;
});

const openDocument = () => {
    window.open(documentUrl.value)
}
</script>

<style lang="scss" scoped>
@import "./styles/chat.scss";

.text-link {
    cursor: pointer;
}
.text-link:hover {
    text-decoration: underline;
}
</style>
